// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150232/js/" + chunkId + "." + {"44":"27a80699","225":"1474a7f5","481":"11190ec7","486":"0a0c29fc","770":"6ddc2834"}[chunkId] + ".0.8504076394428469.chunk.js";
};